export default __webpack_public_path__ + "static/media/logo_invisiotrack.00c3aa55.png";